import CT from '@marketplace-ai/tags';

const TAGS = CT.peerRef.form;

export const EndPage = () => {
  return (
    <>
      <div data-cy={TAGS.finished} className="mx-auto max-w-3xl text-left">
        <h2 className="sub-heading-sb mb-5 text-grey-100">Peer Reference Request: Finished</h2>
        <div className="space-y-5">
          <p className="text-sm font-normal leading-7 text-content-secondary">
            Thank you for completing the peer reference form. Your professional assessment and
            honest feedback are invaluable in maintaining the highest standards of healthcare and
            ensuring quality patient care.
          </p>
          <p className="text-sm font-normal leading-7 text-content-secondary">
            We appreciate the time you took to support your colleague's professional advancement.
            You can now close the window.
          </p>
        </div>
      </div>
    </>
  );
};
